export default function isObject(value) {
  return value !== null && typeof value === 'object'
}
